<template>
    <v-btn block color="#0054A6" @click="handleClick" class="custom-button">
      <v-icon left>mdi-calendar</v-icon>
      {{ buttonText }}
    </v-btn>
</template>

<script>
    export default{
        name: 'BookSlotButton',
        props: {
            buttonText: {
                type: String,
                required: true,
            },
        },
        methods : {
            handleClick() {
                this.$emit('on-button-click');
            }
        }
    }
</script>

<style scoped>
    .custom-button {
        color: white;
        text-transform: none;
        height: 56px;
        border-radius: 8px;
    }

    .v-btn--block {
        flex: none;
    }
</style>